import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { AppState } from './app-state';
import reducers from './reducers-config';

const storesToPersist: string[] = [
    'authState'
];

const persistedReducer = persistReducer({
    key: 'appState',
    storage,
    whitelist: storesToPersist
}, reducers);

const middlewares = [thunk];

const store: Store<AppState> = createStore(
    persistedReducer, 
    composeWithDevTools(applyMiddleware(...middlewares))
);

const persistor = persistStore(store);

export { store, persistor };

